import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/exo-2/400.css";
import "@fontsource/exo-2/700.css";
import { AppManager } from "@kiddocare-platform/portal-common/contexts";
import { LoaderManager } from "@kiddocare-platform/portal-common/ui";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import loaderPrimary from "./assets/loader-primary.json";
import { ConfigHelper } from "./helpers/config.helper";

console.log(`
  ██╗  ██╗ ██╗ ██████╗  ██████╗   █████   ██████╗ █████╗   ██████╗  ███████╗
  ██║ ██╔╝ ██║ ██╔══██╗ ██╔══██╗ ██╔══██╗ ██╔═══╝ ██╔══██╗ ██╔══██╗ ██╔════╝
  █████╔╝  ██║ ██║  ██║ ██║  ██║ ██║  ██║ ██║     ███████║ ██████╔╝ █████╗  
  ██╔═██╗  ██║ ██║  ██║ ██║  ██║ ██║  ██║ ██║     ██╔══██║ ██╔══██╗ ██╔══╝  
  ██║  ██╗ ██║ ██████╔╝ ██████╔╝ ╚█████╔╝ ╚█████╗ ██║  ██║ ██║  ██║ ███████╗
  ╚═╝  ╚═╝ ╚═╝ ╚═════╝  ╚═════╝   ╚════╝   ╚════╝ ╚═╝  ╚═╝ ╚═╝  ╚═╝ ╚══════╝
  Administrator
  © ai-health 2025
`);

AppManager.Setup({
  portal: 'patient',
  urlCommunicationNotificationService: import.meta.env.VITE_API_COMMUNICATION_URL,
  urlPlatformRegistryService: import.meta.env.VITE_API_PLATFORM_URL,
  authConfig: ConfigHelper.GetAuthConfig(),
  firebaseConfig: ConfigHelper.GetFirebaseConfig()
});
LoaderManager.Setup(loaderPrimary);
console.log("Inizializzazione completata");

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);


/*import { createRoot } from "react-dom/client";
import { App } from "./app";

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);*/


/*import { ChakraProvider, createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Toaster } from './components/ui/toaster.component';
import { theme } from './constants/theme.constant';
import { AuthProvider } from './contexts/auth.context';

// Crea le configurazioni per il thema
const myconfig = defineConfig({ strictTokens: true, theme: theme });
const system = createSystem(defaultConfig, myconfig);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ChakraProvider value={system}>
    <ThemeProvider attribute="class" defaultTheme="system" disableTransitionOnChange enableSystem>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </ChakraProvider>
);*/



/*root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);**/

/*
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);*/
